export enum AdditionalCustomValidation {
  ORGANIZATION_NAME = 'organization_name',
}
